import React, { useState, useEffect } from 'react';
import styles from '../styles.module.scss';

interface EditPlaceholderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, isRequired: boolean) => void;
  currentName: string;
  currentRequired: boolean;
  isSaving?: boolean;
}

const EditPlaceholderModal: React.FC<EditPlaceholderModalProps> = ({
  isOpen,
  onClose,
  onSave,
  currentName,
  currentRequired,
  isSaving = false,
}) => {
  const [name, setName] = useState(currentName);
  const [isRequired, setIsRequired] = useState(currentRequired);

  // Reset form when modal opens with new values
  useEffect(() => {
    if (isOpen) {
      setName(currentName);
      setIsRequired(currentRequired);
    }
  }, [isOpen, currentName, currentRequired]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) return;
    onSave(trimmedName, isRequired);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && !isSaving) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.deleteModal} onClick={handleOverlayClick}>
      <div className={styles.deleteModalContent} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.deleteModalTitle}>Edit Placeholder</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.editFormField}>
            <label className={styles.fieldLabel}>Name</label>
            <input
              type="text"
              className={styles.valueInput}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter placeholder name..."
              autoFocus
              disabled={isSaving}
            />
          </div>
          <div className={styles.editFormField}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={isRequired}
                onChange={(e) => setIsRequired(e.target.checked)}
                disabled={isSaving}
              />
              <span>Required field</span>
            </label>
          </div>
          <div className={styles.deleteModalActions}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={onClose}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={styles.applyButton}
              disabled={!name.trim() || isSaving}
              style={{ width: 'auto', margin: 0 }}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPlaceholderModal;
